// Formatting postcode entered by user in checkout page.
jQuery(document).ready(function() {  
  jQuery("#checkout_shipping_address_zip").keyup(function () {
    var newPostCode = checkPostCode(document.getElementById('checkout_shipping_address_zip').value);
    if (newPostCode) {
      document.getElementById('checkout_shipping_address_zip').value = newPostCode;
    }
  });
});

// Need to add this code in checklist
jQuery('label[for="checkout_payment_gateway_19634978927"]').addClass('dividebuy-checkout-page');

// Function for displaying instalment data on DivideBuy payment description area.
function displayDivideBuyPaymentDescription(minimumOrder, installMents) {
  // Getting cart grand total.
  var cart_total = jQuery(".payment-due__price").text();
  var cart_total_without_currency = jQuery(".payment-due__price").text().replace('£', '');
  //cart_total_without_currency = cart_total_without_currency.replace(',', '')
  cart_total_without_currency = cart_total_without_currency.replace(',', '').trim();
  var a = 1;
  
  if(parseFloat(cart_total_without_currency) < parseFloat(minimumOrder)) {
    var required_order_amount = minimumOrder - cart_total_without_currency;
    jQuery("#payment-gateway-subfields-39228670014").html("To qualify for Interest-Free Credit with DivideBuy, please spend a further £"+ required_order_amount +".");
  } else {
    // Updating DivideBuy payment method description.
    var dbhtml = "<form method='post' id='dividebuy-payment-form'>";
    dbhtml += "<div class='dividebuy-payment-description'>";
    dbhtml += "<p class='payment-title'>Choose your monthly payment plan:</p>";
    dbhtml += "<p class='payment-note'>Note: Your first instalment will be collected on completion of your order.</p>";
    dbhtml += "<div class='dividebuy-checkout-row dividebuy-checkout-header'>";
    dbhtml += "<div class='dividebuy_instalment_data'>";
    dbhtml += "<div class='data'>";
    dbhtml += "<span class='dividebuy-blankspace interest-input'></span>";
    //dbhtml += "<span class='interest-main-figure'>Number of Months</span>";
    dbhtml += "<span class='interest-main-figure'>Months</span>";
    dbhtml += "</div>";
    dbhtml += "</div>";
    
    dbhtml += "<div class='dividebuy_instalment_data-2'>";
    dbhtml += "<div class='data'>";
    //dbhtml += "<span class='interest-digit'>Monthly Instalments</span>";
    dbhtml += "<span class='interest-digit'>In Total You'll Pay</span>";
    dbhtml += "</div>";
    dbhtml += "<div class='data'>";
    //dbhtml += "<span class='interest-digit'>Interest (0% APR)</span>";
    dbhtml += "<span class='interest-digit'>Interest Rate (Fixed)/ APR</span>";
    dbhtml += "</div>";
    dbhtml += "<div class='data'>";
    //dbhtml += "<span class='interest-digit'>Total</span>";
    dbhtml += "<span class='interest-digit'>Monthly Payment</span>";
    dbhtml += "</div>";
    dbhtml += "</div>";
    dbhtml += "</div>";
    
    
    for(value in installMents ) {
      var month = installMents[value].key;
      var month_cost = '£' + (cart_total_without_currency / installMents[value].key).toFixed(2);
      var compare_price = installMents[value].value;

      var intererstRate =  instalments[value].interest_rate / 100;
      var installments_details = calculateInstalmentAmountsForLoan(cart_total_without_currency,intererstRate,month);
  
      if(parseFloat(compare_price) <= parseFloat(cart_total_without_currency.trim())) {
        if(a == 1) {
          dbhtml += "<div class='dividebuy-checkout-row dividebuy-active-row'>"
          dbhtml += "<div class='dividebuy_instalment_data'>";
          dbhtml += "<div class='data'><span class='interest-input'> <input class='input-radio' type='radio' name='dividebuy_available_instalments' value='"+month+"' checked='checked'/></span><div class='interest-main-figure'><span class='interest-figure'>"+ month +"</span></div></div>";  
          dbhtml += "</div>";
          dbhtml += "<div class='dividebuy_instalment_data-2'>";
          // dbhtml += "<div class='data'><span class='interest-figure'>"+ month_cost +"</span></div>";
          // dbhtml += "<div class='data'><span class='interest-digit'>£0.00</span></div>";
          // dbhtml += "<div class='data'><span class='interest-digit'> "+ cart_total +"</span></div>";
          dbhtml += "<div class='data'><span class='interest-figure'>£"+parseFloat(installments_details['totalToPay']).toFixed(2)+"</span></div>";
          dbhtml += "<div class='data'><span class='interest-digit'>"+parseFloat(instalments[value].interest_rate).toFixed(2)+"%</span></div>";
          dbhtml += "<div class='data'><span class='interest-digit'>£"+ calcNumber(installments_details['regularMonthlyInstalment']) +"</span></div>";       
          dbhtml += "</div>"; 
          dbhtml += "</div>"
        } else {
          dbhtml += "<div class='dividebuy-checkout-row'>"
          dbhtml += "<div class='dividebuy_instalment_data'>";
          dbhtml += "<div class='data'><span class='interest-input'> <input class='input-radio' type='radio' name='dividebuy_available_instalments' value='"+month+"' /></span><div class='interest-main-figure'><span class='interest-figure'>"+ month +"</span></div></div>";  
          dbhtml += "</div>";
          dbhtml += "<div class='dividebuy_instalment_data-2'>";
          // dbhtml += "<div class='data'><span class='interest-figure'>"+ month_cost +"</span></div>";
          // dbhtml += "<div class='data'><span class='interest-digit'>£0.00</span></div>";
          // dbhtml += "<div class='data'><span class='interest-digit'> "+ cart_total +"</span></div>";
          dbhtml += "<div class='data'><span class='interest-figure'>£"+parseFloat(installments_details['totalToPay']).toFixed(2)+"</span></div>";
          dbhtml += "<div class='data'><span class='interest-digit'>"+parseFloat(instalments[value].interest_rate).toFixed(2)+"%</span></div>";
          dbhtml += "<div class='data'><span class='interest-digit'>£"+ calcNumber(installments_details['regularMonthlyInstalment']) +"</span></div>";
          dbhtml += "</div>"; 
          dbhtml += "</div>"
        }        
      }
      a++;
    }
    dbhtml += "<p class='security-reason'>For security reasons, your billing and delivery addresses must match if choosing Interest-Free Credit with DivideBuy.</p>";
    dbhtml += "</div>";
    dbhtml += "</form>";

    jQuery("#payment-gateway-subfields-19634978927").html(dbhtml);
    
    // Code for changing div class when instalment value changed by user.
    jQuery('input[name=dividebuy_available_instalments]').change(function(){ 
       //first remove class from all
       jQuery('input[name=dividebuy_available_instalments]').parents('div.dividebuy-checkout-row').removeClass("dividebuy-active-row");

       //now add the class to checked radio
       if(jQuery(this).is(":checked")){
           jQuery(this).parents('div.dividebuy-checkout-row').addClass("dividebuy-active-row");
       }
    });
  }
}
/**
 * A helper function to calculate the instalment costs of a given amount over a number of months, 
 * with a defined monthly compound interest rate.
 * 
 * This calculation is used twice within this function, hence the creation of this helper function.
 */
function calculateInstalmentAmount(amount, monthlyIR, numberOfMonths, roundingPrecision = 6) {
  return parseFloat(
      (amount * monthlyIR) / (1 - Math.pow(1 + monthlyIR, (numberOfMonths * -1))),
      roundingPrecision
  );
}
function calculateInstalmentAmountsForLoan(loanAmount, interestRate, monthsInAgreement) {
  if(interestRate == '0')
  {
    instalment =  loanAmount / monthsInAgreement;
    return {
      'totalAmount' : loanAmount,
      'interestRate' : 0,
      'monthlyInterestRate' : 0,
      'numberOfMonths' : monthsInAgreement,
      'firstInstalment' : instalment,
      'regularMonthlyInstalment' : instalment, 
      'totalToPay' : loanAmount,
      'totalLoanValue' : loanAmount - instalment,
      'interest' : 0,
      'effectiveTerm' : monthsInAgreement - 1,
    }
  }
  // Calculate the monthly interest rate
  monthlyInterestRate = Math.pow((interestRate + 1) , (1 / 12)) - 1;
  // Establish the initial payment to be made by the customer
  // This is INTEREST FREE, and MUST be calculated in pence.
  loanAmountInPence = loanAmount * 100;
  initialRemainder = fmod(loanAmountInPence, monthsInAgreement);
  initialRegularInstalment = (loanAmountInPence - initialRemainder) / monthsInAgreement;
  firstInstalment = (initialRegularInstalment + initialRemainder) / 100;
  // The loan principle is the amount left after the initial payment has been made. This is the amount that is
  // actively being loaned, which will require interest
  loanPrincipal = loanAmount - firstInstalment;
  // Establish the monthly rate for this new loan principal amount, to be paid across one fewer instalments than
  // defined, as the first instalment has already been paid. 
  // This is required as we need to calculate interest on the slightly lower amount of the loan principle, not
  // against the amount of the original order.
  monthlyInstalment = calculateInstalmentAmount(loanPrincipal, monthlyInterestRate, monthsInAgreement - 1);
  // Calculate the total to be paid, and the interest that includes
  totalToPay = (monthlyInstalment * (monthsInAgreement - 1)) + firstInstalment;
  interestToPay = totalToPay - loanAmount;
  return {
      'totalAmount' : loanAmount,
      'interestRate' : interestRate,
      'monthlyInterestRate' : monthlyInterestRate,
      'numberOfMonths' : monthsInAgreement,
      'firstInstalment' : firstInstalment,
      'regularMonthlyInstalment' : monthlyInstalment,
      'totalToPay' :  totalToPay,
      'totalLoanValue' : totalToPay - firstInstalment,
      'interest' : interestToPay,
      'effectiveTerm' : monthsInAgreement - 1,
  }
}
function fmod(dividend, divisor){
  var multiplier = 0;
  while(divisor * multiplier < dividend)
  {
    ++multiplier;
  }
  --multiplier;
  return dividend - (divisor * multiplier);
}
function bcdiv(first,second,scale=2){
  return parseFloat(first/second).toFixed(2);
}
function calcNumber(num) {
  return num.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0];
}
// Getting cart details in checkout page on complete order button click.
jQuery(".shown-if-js .step__footer__continue-btn").click(function(){
  jQuery.ajax({
    type: 'GET',
    url: '/cart.js',
    cache: false,
    dataType: 'json',
    success: function(cart) {        
      var current_url_path = window.location.pathname;
      var cart_token = current_url_path.lastIndexOf("/");
      var cart_token_final = current_url_path.substring(cart_token + 1);
      var selected_instalment_value = jQuery('input[name=dividebuy_available_instalments]:checked').val();

      if(selected_instalment_value){
        jQuery.ajax({
          type: 'POST',
          url: 'https://gateway.dividebuy.co.uk/api/update-instalment-key',
          data: {cart_token:cart_token_final, selected_instalment_key:selected_instalment_value},
          cache: false,
          dataType: 'json',
          success: function(response) {
          }
        });
      }
    }
  });
});

// DivideBuy soft credit check.
function displaySoftCreditPopupCheckout(retailerBaseUrl, minimumOrder) {
  var cart_total = jQuery(".payment-due__price").text();
  var cart_total_without_currency = jQuery(".payment-due__price").text().replace('£', '');
  cart_total_without_currency = cart_total_without_currency.replace(',', '');
  cart_total_without_currency = cart_total_without_currency.trim();

  var softCreditHtml = '<div class="dividebuy-softcredit">';
  softCreditHtml += '<div class="dividebuy-softsearch">';
  // softCreditHtml += '<a href="javascript:void(0)" class="link-dividebuy-softsearch"><span>Get Pre-Approved</span></a>';
  softCreditHtml += '<a href="javascript:void(0)" class="link-dividebuy-softsearch"><span>Check Eligibility</span></a>';
  softCreditHtml += ' Fast check - won\'t affect your credit rating';
  softCreditHtml += '</div></div>';

  // Appending data to payment description bottom area.
  var gatewayId = jQuery('.payment-note').parent().parent().attr('id');
  if(gatewayId !== undefined){
    var checkoutCode = gatewayId.substr(gatewayId.lastIndexOf('-') + 1);
    jQuery('label[for="checkout_payment_gateway_' + checkoutCode + '"]').append(softCreditHtml);
  }

  if(parseFloat(cart_total_without_currency) >= parseFloat(minimumOrder)){
    jQuery(".link-dividebuy-softsearch").click(function(){
      getSplashKeyUrl(retailerBaseUrl, cart_total_without_currency, "checkout");
    });
  }else {
    jQuery(".link-dividebuy-softsearch").click(function(){
      getSplashKeyUrl(retailerBaseUrl, minimumOrder, "checkout");
    });
  }
  
  // Close soft search popup.
  jQuery(document).click("#softcredit-scroll", function(){
    closeSoftCreditPopup();
  });
}


// Function for getting softsearch URL
function getSplashKeyUrl(retailerBaseUrl, grandTotal, page) {
  var apiParams = {};
  apiParams['retailer_base_url'] = retailerBaseUrl;
  apiParams['order_total'] = grandTotal;

  jQuery.ajax({
    url: 'https://gateway.dividebuy.co.uk/api/get-softsearch-key', // Determining far end
    data: JSON.stringify(apiParams), // Obtaining proper JSON string from data object
    processData: false, // Preventing default data parse behavior
    contentType: "application/json", // Setting proper `ContentType` for our data
    type: "POST",

  }).done(function( response ) {
    if(response)
    {
      displayCreditPopup(response.splashKey, page);
    }
  })
}